import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={13}
    height={12}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.248 4.19V0h1.5v4.285L11.133.9l1.061 1.06-3.289 3.29h4.093v1.5h-4.19l3.386 3.385-1.06 1.061-3.386-3.385V12h-1.5V7.907L2.96 11.196l-1.06-1.06L5.283 6.75H.998v-1.5h4.19l-3.29-3.29L2.96.9l3.29 3.29Z"
      fill="#3866BB"
    />
  </svg>
);

export default SvgComponent;
